<template>
	<JFlex class="s-items-center">
		<JSelect :options="insurers" :value="value" v-on="$listeners" />
		<JSpinner type="dots" v-if="isLoading" :delay="200" />
	</JFlex>
</template>

<script>
import api from "@/api/api"
import { query } from "../api/queries"

export default {
	props: {
		value: {
			type: String,
			default: ""
		}
	},

	data() {
		return {
			isLoading: false,
			insurers: []
		}
	},

	methods: {
		async fetchInsurers() {
			if (this?.insurers?.length) return

			this.isLoading = true
			const res = await api({ query: query.insurers })
			this.isLoading = false

			this.insurers = res?.data?.insurers?.map(item => ({ name: item.name, value: item.id }))
		}
	},

	created() {
		this.fetchInsurers()
	}
}
</script>
